import { Routes } from '@angular/router';
import {InboxComponent} from './components/inbox/inbox.component';
import { MailTemplateContentComponent } from './components/mail-template-content/mail-template-content.component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';

export const inboxRoutes: Routes = [
  {
    path     : 'mail/:label',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'mail/:label/:mailId',
    component: InboxComponent
  },
];
